import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { AuthTransition } from '@/Module/Auth/Component';
import { LINKS } from '@/Module/Core/Constant';
import { enqueueError, logError } from '@/Module/Core/Helper';
import { useAppDispatch } from '@/Module/Store/Hook';
import { ScriptContainer, ThankYouFailed } from '@/Module/Subscription/Component';
import type { IVerifyPaymentScript } from '@/Module/Subscription/Model/ApiModel';
import { postVerifyPaymentRequestAction } from '@/Module/Subscription/Store/Action';
const SubscriptionThankYouTwoPageContainer = () => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const [verificationData, setVerificationData] = useState<IVerifyPaymentScript | null>(null);
  const orderId = Number(router?.query.slug);
  useEffect(() => {
    dispatch(postVerifyPaymentRequestAction(orderId)).unwrap().then(data => {
      setVerificationData(data);
    }).catch(error => {
      if (error?.response?.status === 401) {
        router.push(`${LINKS.SUBSCRIPTION.BUY}${orderId}/`);
      } else {
        enqueueError('پرداخت شما موردتایید نیست. لطفاً با پشتیبانی تماس بگیرید!');
        logError('Payment not verified!', error);
      }
    });
  }, [orderId]);
  if (!verificationData) return <AuthTransition />;
  return verificationData?.isSuccess ? <ScriptContainer {...verificationData} data-sentry-element="ScriptContainer" data-sentry-component="SubscriptionThankYouTwoPageContainer" data-sentry-source-file="SubscriptionThankYouTwoPageContainer.tsx" /> : <ThankYouFailed orderId={orderId} data-sentry-element="ThankYouFailed" data-sentry-component="SubscriptionThankYouTwoPageContainer" data-sentry-source-file="SubscriptionThankYouTwoPageContainer.tsx" />;
};
export default SubscriptionThankYouTwoPageContainer;